module.exports = __webpack_public_path__ + "static/media/store1.b1f3d6d3.jpg";